import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { encryptAES } from "../../Common/Axios/encrypt";
import getTranslation from "../../TranslationUtility/TranslationUtility";
import feature from "../../Assets/imgNewUI/featured.svg";
import arrowRightImg from "../../Assets/img/arrow-right.svg";
import ArrowForwardIcon from "../../Assets/imgNewUI/arrow_forward_Home.svg";
import { DealCouponFreqData, FormatCardTypes, FormatDate, GetMerchantBgColor, ThemeData } from "../../Utility/Utility";

const CommonOffer = ({
    deal,
    matchingCoupon,
    isFeature,
    handleDealCoupon,
    bgImg,
    index,
    couponCount,
    isMobileView,
}) => {
    const navigate = useNavigate();
    const translation = getTranslation();
    const themeData = ThemeData();
    const merchantBgColor = GetMerchantBgColor(deal, themeData);
    const clientMasterData = useSelector((state) => state.clientMasterReducer);
    const clientData = clientMasterData?.clientMasterData || [];
    const clientCode = clientData?.[0]?.clientCode;
    const { dealCoupounFrequencies } = useSelector((state) => state?.dealsDataSlice?.allofferData);
    const { dealCouponFreqData } = DealCouponFreqData();
    const dealCoupounFrequenciesList = [...dealCouponFreqData, ...dealCoupounFrequencies || []];

    const earliestExpiringCoupoun = matchingCoupon?.reduce((earliest, current) => {
        const currentFrequency = dealCoupounFrequenciesList?.find(
            (code) => code?.dealCoupounId === current?.id
        );
        earliest.push({ ...current, ...currentFrequency });
        return earliest;
    }, []).sort((a, b) => new Date(a?.validUpto) - new Date(b?.validUpto))[0];

    console.log(earliestExpiringCoupoun);

    const handleClaim = (dealData) => {
        if (!isMobileView) {
            const target = `/Offers?did=${encryptAES(String(dealData?.id))}`;
            // Cards on the merchant page itself reuse this component — don't push the page's own
            // URL again, it just adds a duplicate history entry the back button then lands on.
            if (target !== `${window.location.pathname}${window.location.search}`) navigate(target);
        }
        if (typeof handleDealCoupon === "function") {
            handleDealCoupon(dealData);
        }
    };

    const cardTypes = FormatCardTypes(earliestExpiringCoupoun || [], translation);

    const badgePriority = [
        translation?.badgeFeatured,
        translation?.badgeExpiringSoon,
        translation?.badgeNew,
    ];

    const badgeColors = {
        [translation?.badgeFeatured]: { bg: "var(--offer-badge-featured-bg, #8B4EC7)", text: "var(--offer-badge-featured-text, #FFFFFF)" },
        [translation?.badgeExpiringSoon]: { bg: "var(--offer-badge-expiring-bg, #9C4424)", text: "var(--offer-badge-expiring-text, #FFFFFF)" },
        [translation?.badgeNew]: { bg: "var(--offer-badge-new-bg, #0F8068)", text: "var(--offer-badge-new-text, #FFFFFF)" },
    };

    const offerBadge = badgePriority?.find(priority =>
        matchingCoupon?.some(c => c?.offerBadge === priority)
    );
    return (
        <div key={index} className="new-offer-img-width">
            {/* New Card Design */}
            <div className="new-offer-card" onClick={() => handleClaim(deal)}>
                {offerBadge && <div className="offer-card-badge" style={{ backgroundColor: badgeColors[offerBadge]?.bg }}>
                    <span className="badge-text" style={{ color: badgeColors[offerBadge]?.text }}>{offerBadge}</span>
                </div>}

                {/* Card Header */}
                <div className="offer-card-header">
                    <div className="offer-card-brand" style={merchantBgColor ? { backgroundColor: merchantBgColor } : undefined}>
                        <img
                            src={isMobileView
                                ? deal?.mobImage
                                    ? `${process.env.REACT_APP_CLIENT_IMAGE_URL}${deal.mobImage}`
                                    : `${process.env.REACT_APP_CLIENT_IMAGE_URL}${clientCode}/img/Placeholder.svg`
                                : deal?.webImage
                                    ? `${process.env.REACT_APP_CLIENT_IMAGE_URL}${deal.webImage}`
                                    : `${process.env.REACT_APP_CLIENT_IMAGE_URL}${clientCode}/img/Placeholder.svg`}
                            alt={earliestExpiringCoupoun?.title}
                            className="brand-logo"
                            onError={(e) => (e.target.src = `${process.env.REACT_APP_CLIENT_IMAGE_URL}${clientCode}/img/Placeholder.svg`)}
                        />
                    </div>
                </div>

                {/* Card Body */}
                <div className="offer-card-body">
                    <div>
                        <h3 className="offer-card-title">{deal?.name}</h3>
                        <div className="offer-card-amount">
                            {earliestExpiringCoupoun?.title}
                        </div>
                    </div>

                    <div className="offer-card-info">
                        <span className={cardTypes ? "info-label" : "info-label-empty"}>{cardTypes || "\u00A0"}</span>
                    </div>

                    <div className="offer-card-expiry">
                        <div className="expiry-info">
                            <span className="expiry-label">{translation?.expiresOn}</span>
                            <span className="expiry-date">{FormatDate(earliestExpiringCoupoun?.validUpto)}</span>
                        </div>
                        <div className="offer-card-arrow">
                            <img src={ArrowForwardIcon} alt=">" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CommonOffer;
